<template>
    <div class="profile-dashboard__desk-list dashboard_contents">

        <div class="profile-dashboard__desk-notification" v-if="notifications.length && loaded">
            <div class="profile-dashboard__desk-item" v-for="(item, idx) in notifications" :key="idx">

                <info @refreshTab="getNotifications" :notice="item" v-if="item.category === 'info'"/>
                <moderation @refreshTab="getNotifications" :user="user" :notice="item" v-if="item.category === 'interactive'"/>
                <payments @refreshTab="getNotifications" :notice="item" v-if="item.category === 'payments'"/>

            </div>
        </div>
        <div class="profile-dashboard__desk-notification" v-else-if="!loaded">
            <div class="profile-dashboard__desk-item profile-dashboard__desk-item--empty d-flex">
                <div class="LoaderBalls">
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                </div>
            </div>
        </div>
        <div class="profile-dashboard__desk-notification" v-else>
            <div class="profile-dashboard__desk-item profile-dashboard__desk-item--empty d-flex">
                Список уведомлений пуст
            </div>
        </div>

    </div>
</template>

<script>

import Info from '../tabs/TabNotice/NoticeInfo'
import Moderation from '../tabs/TabNotice/NoticeModeration'
import Payments from '../tabs/TabNotice/NoticePayments'

export default {
    name: "UserDashboardNotice",
    components: {Info, Moderation, Payments},
    props: ['user'],
    data(){
        return{
            notifications: [],
            loaded: false,
        }
    },

    mounted(){
      this.getNotifications()
    },
    watch:{
        notifications(){
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        }
    },
    methods:{

        getNotifications(){
            let url = '/api/notifications',
                params = {
                    category : null,
                    page: 1,
                    since: null,
                    till: null,
                    per_page: 30,
                };

            axios.get(url,{params: params})
                .then(response =>{

                    this.loaded = false

                    response = response.data
                    if(response){
                        this.notifications = response.data
                    }
                })
                .catch()
        },
    }



}
</script>

<style lang="scss" scoped>

.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6,.05,.15,.95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}


</style>
